import { useLocale } from '../../../store/i18nMessage';
import { TrashIcon } from '@bfe/moly-icons';

import styles from './index.module.scss';

interface Props {
  historyList: string[];
  handleInput: (input: string) => void;
  onClear: () => void;
}

export const SearchHistory = (props: Props) => {
  const { historyList, handleInput, onClear } = props;
  const { t } = useLocale();

  return (
    <div className={styles.container}>
      <div className={styles.titleArea}>
        <div className={styles.title}>{t('searchHistory')}</div>
        <TrashIcon className={styles.delete} onClick={onClear} />
      </div>
      <div className={styles.historyArea}>
        {historyList.map((item, index) => {
          return (
            <div
              className={styles.cell}
              key={index}
              onClick={() => {
                handleInput(item);
              }}
            >
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};
